import type { JSX } from 'react';
import type { useContractorState } from '@/hooks/useContractorState';
import { Input, Checkbox } from '../ui';

type ContractorState = ReturnType<typeof useContractorState>;

interface Props {
  state: Pick<
    ContractorState,
    | 'vatRegistered'
    | 'setVatRegistered'
    | 'vatUsingFlatRateScheme'
    | 'setVatUsingFlatRateScheme'
    | 'vatFlatRatePercentage'
    | 'setVatFlatRatePercentage'
  >;
}

export function VATFormSection({ state }: Props): JSX.Element {
  return (
    <div className="space-y-4">
      <Checkbox
        checked={state.vatRegistered}
        onChange={(e) => state.setVatRegistered(e.target.checked)}
        label="VAT Registered"
        helperText="Required if annual revenue exceeds £90,000"
      />

      {state.vatRegistered && (
        <>
          <Checkbox
            checked={state.vatUsingFlatRateScheme}
            onChange={(e) => state.setVatUsingFlatRateScheme(e.target.checked)}
            label="Using Flat Rate Scheme"
            helperText="Simplified VAT with fixed percentage"
          />

          {state.vatUsingFlatRateScheme && (
            <Input
              label="Flat Rate Percentage"
              helperText="E.g., 14.5% for IT contractors (13.5% in first year)"
              type="number"
              suffix="%"
              value={state.vatFlatRatePercentage ?? ''}
              onChange={(e) =>
                state.setVatFlatRatePercentage(
                  e.target.value ? Number(e.target.value) : null
                )
              }
              min={0}
              max={20}
              step={0.5}
              fullWidth
              selectAllOnFocus
            />
          )}
        </>
      )}
    </div>
  );
}
